import i18n from "../../plugins/I18nPlugin";

export function numberHigherRule(
  higherValue: number,
  message = "components.thg.ThgQuoteUpdateDialog.ruleHigher"
): (value: any) => boolean | string {
  return value => value >= higherValue || String(i18n.tc(message)) + " " + higherValue;
}

export function numberHigherOrNullOrUndefinedRule(
  higherValue: number,
  message = "components.thg.ThgQuoteUpdateDialog.ruleHigher"
): (value: any) => boolean | string {
  return value =>
    value === null || value === undefined || value >= higherValue || String(i18n.tc(message)) + " " + higherValue;
}
